import React from 'react';
import { Route, Routes } from 'react-router-dom';
import ListPrivacyPolicies from './list-privacy-policies';
import PrivacyPolicyDetail from './privacy-policy-detail';
import Header from '../common/components/header';
import Sidebar from '../common/components/sidebar';

const PrivacyPolicyRoutes = () => (
  <>
    <Header />
    <Sidebar />
    <div className="page-wrapper">
      <div className="content">
        <Routes>
          <Route path="/list-privacy-policies" element={<ListPrivacyPolicies />} />
          <Route path="/privacy-policy-detail/:id" element={<PrivacyPolicyDetail />} />
          <Route path="/" element={<ListPrivacyPolicies />} />
        </Routes>
      </div>
    </div>
  </>
);

export default PrivacyPolicyRoutes;

